<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Визиты</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-layout style="padding-left: 25px;padding-right: 25px;" card color="white">
              <v-flex v-for="sd in detailedSearch" :key="sd.searchKey">
                <v-text-field flat prepend-icon="search" :placeholder="sd.placeholder" v-model="sd.text" hide-details
                  clearable class="hidden-sm-and-down" @click:clear="clearSearchField"
                  v-on:keyup.enter="pressEnterSearch"></v-text-field>
              </v-flex>
              <v-btn @click="detailedSearchClear" icon>
                <v-icon>clear_all</v-icon>
              </v-btn>
            </v-layout>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :items="visitData" :total-items="countVisits"
                :rows-per-page-items="[10]" :loading="visitData.length === 0" :pagination.sync="pagination"
                :options.sync="options" @update:pagination="updatePagination" class="elevation-1" item-key="visitUid"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>{{ props.item.visitDate.split('.')[0] }}</td>
                  <td>{{ props.item.gpsTimestamp !== null ? props.item.gpsTimestamp.split('.')[0] : '' }}</td>
                  <td>
                    <v-icon color="teal" v-if="props.item.isActive == 1">check</v-icon>
                    <v-icon color="error" v-if="props.item.isActive == 0">error</v-icon>
                  </td>
                  <td>{{ props.item.fullName }}</td>
                  <td>{{ props.item.employeeName }}</td>
                  <td>{{ props.item.shopEmployeeId }}</td>
                  <td>{{ props.item.shopName }}</td>
                  <td>{{ props.item.shopId }}</td>
                  <td>{{ props.item.visitTypeName }}</td>
                  <td>{{ props.item.visitToShop }}</td>
                  <td>
                    <v-btn flat icon dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn flat icon dark color="primary" small @click="answerOpen(props.item)">
                      <v-icon>list</v-icon>
                    </v-btn>
                    <v-btn flat icon dark small @click="deactivationConfirm(props.item)">
                      <v-icon v-if="props.item.isActive" color="pink">done_outline</v-icon>
                      <v-icon v-if="!props.item.isActive" color="teal">done_outline</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editIndex !== -1">Редактирование</span>
                      <span class="headline" v-if="editIndex === -1">Добавление</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>UID визита</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field disabled label="UID визита" v-model.lazy="modalData.visitUid" readonly
                              :rules="[rules.required]"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ID аккаунта</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field disabled label="ID аккаунта" v-model.lazy="modalData.accountId" readonly
                              :rules="[rules.required]"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ID ответственного</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field disabled label="ID ответственного" v-model.lazy="modalData.staffId" readonly
                              :rules="[rules.required]"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ID клиники</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field disabled label="ID клиники" v-model.lazy="modalData.shopId" readonly
                              :rules="[rules.required]"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ID стоматолога</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field v-if="modalData.visitTypeId !== 3" disabled label="ID стоматолога"
                              v-model.lazy="modalData.shopEmployeeId" readonly :rules="[rules.required]"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Дата визита</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-datetime-picker label="Выберете дату и время" locale="ru-ru" clearText="Очистить"
                              @input="changeDate($event)" v-model="modalData.visitDate"></v-datetime-picker>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Ответственный</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete disabled label="Ответственный" :items="staffList"
                              v-model="modalData.staffId" return-object @change="changeStaff($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Стоматолог</v-subheader>
                          </v-flex>
                          <v-flex xs8 v-if="modalData.visitTypeId !== 3">
                            <v-btn v-show="changeEmployeeTrigger" @click="changeEmployeeTrigger = false" depressed>{{
                              modalData.employeeName }}</v-btn>
                            <v-autocomplete v-show="!changeEmployeeTrigger" @blur="changeEmployeeTrigger = true"
                              label="Стоматолог" :items="employeeListVisit" no-data-text="Нет доступных стоматологов"
                              v-model="modalData.shopEmployeeId" return-object autofocus
                              @change="changeEmployee($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Клиника</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete disabled label="Клиника" :items="clinicList" v-model="modalData.shopId"
                              return-object @change="changeClinic($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Дистанция</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field disabled label="Дистанция" v-model.lazy="modalData.distance"
                              readonly></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Визит в ТТ</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-radio-group v-if="shopLocation" v-model="modalData.visitToShop" row>
                              <v-radio label="Да" value="Да"></v-radio>
                              <v-radio label="Да, ИТ" value="Да, ИТ"></v-radio>
                              <v-radio disabled label="Нет" value="Нет"></v-radio>
                              <v-radio disabled label="Нет координат визита" value="Нет координат визита"></v-radio>
                            </v-radio-group>
                            <strong v-if="!shopLocation">Нет координат клиники!</strong>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Просмотр анкет с вопросами -->
              <div slot="widget-content">
                <v-dialog v-model="popupAnswer.isOpen" persistent max-width="900px">
                  <v-card>
                    <v-card-title>
                      <v-flex xs3>
                        <span class="headline">Вопросы и ответы</span>
                      </v-flex>
                      <v-flex xs7>
                        <v-subheader>
                          {{ this.popupAnswer.data.visitDate }} - {{ popupAnswer.data.employeeName }}
                          <br />
                          {{ popupAnswer.data.shopName }}
                        </v-subheader>
                      </v-flex>
                      <v-flex xs2>
                        <v-btn color="green" dark small @click="openAddTemplate()">
                          <v-icon>add</v-icon>анкету
                        </v-btn>
                      </v-flex>
                    </v-card-title>
                    <div style="overflow-y: scroll; height: 700px; width: 100%;">
                      <div v-for="poll in pollList">
                        <template>
                          <v-alert :value="true" color="info" icon="info" style="height: 25px;">
                            {{ poll.pollName }}
                            <v-btn color="green" dark small @click="newAnswerOpen(poll)">
                              <v-icon>add</v-icon>Добавить вопрос
                            </v-btn>
                            <v-btn color="red" dark small @click="removePoll(poll)">
                              <v-icon>delete</v-icon>Удалить анкету
                            </v-btn>
                          </v-alert>
                        </template>
                        <v-data-table :headers="complex.headersAnswer" :search="search" :items="answerList" hide-actions
                          class="elevation-1" item-key="questId" no-results-text="Нет результатов"
                          rows-per-page-text="На странице" v-model="complex.selected">
                          <template slot="items" slot-scope="props">
                            <td v-if="poll.pollId == props.item.pollId">{{ props.item.questName }}</td>
                            <td v-if="poll.pollId == props.item.pollId">{{ props.item.numberValue }}</td>
                            <td v-if="poll.pollId == props.item.pollId && props.item.photoUrl == ''">{{
                              props.item.textValue }}</td>
                            <td v-if="poll.pollId == props.item.pollId && props.item.photoUrl != ''">
                              <img
                                style="width: 35%; border-radius: 5px; border-style: solid; border-width: 1px; border-color: blue;"
                                :src="props.item.photoUrl" alt="Фото"/>
                            </td>
                            <td v-if="poll.pollId == props.item.pollId">
                              <v-btn flat icon dark color="primary" small @click="editAnswerOpen(props.item)">
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn flat icon dark color="pink" small @click="removeAnswer(props.item)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                    <v-card-actions>
                      <v-btn flat @click="answerCancel()">Отмена</v-btn>
                      <v-btn color="primary" flat @click="submitAnswer()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Редактирование ответов -->
              <div slot="widget-content">
                <v-dialog v-model="popupEditAnswer.isOpen" persistent max-width="700px">
                  <v-card>
                    <v-card-title>
                      <span v-if="!popupEditAnswer.isNew" class="headline">Редактирование ответов</span>
                      <span v-if="popupEditAnswer.isNew" class="headline">Добавление нового вопроса с ответом</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="formQuest" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Вопрос</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete :disabled="!popupEditAnswer.isNew" label="Вопрос" :items="filtredQuestData"
                              no-data-text="Нет доступных вопросов" v-model="popupEditAnswer.data.questId"
                              :rules="[rules.required]" return-object @change="changeQuests($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout v-if="popupEditAnswer.isQuestValues" row>
                          <v-flex xs4>
                            <v-subheader>Вариант ответа из списка</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Ответ" :items="questValuesList" no-data-text="Нет доступных вопросов"
                              v-model="popupEditAnswer.data.numberValue" return-object
                              @change="changeQuestValues($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout v-if="this.isEmployeeQuest" row>
                          <v-flex xs4>
                            <v-subheader>Стоматолог</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Ответ" :items="employeeListAnswer"
                              no-data-text="Нет доступных стоматологов" v-model="popupEditAnswer.data.numberValue"
                              return-object @change="changeQuestValues($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Текстовое значение</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Ответ" v-model.lazy="popupEditAnswer.data.textValue"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Числовое значение</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Ответ" v-model.lazy="popupEditAnswer.data.numberValue"
                              :rules="[rules.ordering]"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Фото</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <div class="container">
                              <vue-base64-file-upload class="v1" accept="image/png, image/jpeg" input-class="v1-image"
                                disable-preview file-name="Загрузить фото" :max-size="customImageMaxSize"
                                @size-exceeded="onSizeExceeded" @load="onLoad" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <img style="width: 90%;  margin: 20px;" :src="popupEditAnswer.data.photoUrl" alt="Фото"/>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editAnswerCancel()">Отменить</v-btn>
                      <v-btn color="primary" flat @click="submitEditAnswer()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Добавление анкет в визит -->
              <div slot="widget-content">
                <v-dialog v-model="popupAddTemplate.isOpen" persistent max-width="300px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Добавление анкет</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="formTemplate" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Анкета</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Анкета" :items="allPollList" no-data-text="Нет доступных вопросов"
                              v-model="allPollList.name" :rules="[rules.required]" return-object
                              @change="changeTemplate($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="cancelAddTemplate()">Отменить</v-btn>
                      <v-btn color="primary" flat @click="submitAddTemplate()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span v-if="modalData.isActive" class="headline">Вы уверены что хотите деактивировать
                        визит?</span>
                      <span v-if="!modalData.isActive" class="headline">Вы уверены что хотите активировать визит?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionDeactivation(modalData);">Да,
                        уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VueBase64FileUpload from "vue-base64-file-upload";
import { uuid } from "vue-uuid";
import Moment from "moment";
import { extendMoment } from "moment-range";
import VueLodash from "vue-lodash";

const moment = extendMoment(Moment);
export default {
  components: {
    VueBase64FileUpload,
    Moment
  },
  data() {
    return {
      // countVisits: 0,
      options: {},
      isEmployeeQuest: true,
      employeeListAnswer: [],
      photoData: [],
      removePollsUid: [],
      customImageMaxSize: 4, // megabytes
      filtredQuestData: [],
      filtredTemplateQuestData: [], // список обязательных вопросов для новой анкеты
      newAnswerQuest: {},
      updateLocation: false, // флаг для передачи контроллеру, нужно ли обновлять локацию
      shopLocation: false, // есть ли данные по локации клиники для исправления координат визита
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "visitDate",
        descending: true
      },
      modalData: {},
      employeeListVisit: [],
      oldModalData: {},
      editIndex: {},
      editAnswerIndex: {},
      popupCalendar: false,
      valid: true,
      changeEmployeeTrigger: true,
      rules: {
        required: value => !!value || "Поле не может быть пустым.",
        ordering: v =>
          v == null ||
          v == "" ||
          v == 0 ||
          !!parseInt(v) ||
          "Можно использовать только числа"
      },
      search: "",
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      popupAnswer: {
        isOpen: false,
        data: []
      },
      popupEditAnswer: {
        isNew: false,
        isOpen: false,
        isQuestValues: false,
        data: {}
      },
      popupAddTemplate: {
        newTemplateId: "",
        newTemplateName: "",
        isOpen: false,
        data: []
      },
      /**
       * Универсальный объект для детального поиска. Поиск осуществляется в Computed - staffData()
       **/

      detailedSearch: [
        {
          placeholder: "Дата визита",
          searchKey: "visitDate",
          text: ""
        },
        {
          placeholder: "Имя ответственного",
          searchKey: "fullName",
          text: ""
        },
        {
          placeholder: "ФИО стоматолога",
          searchKey: "employeeName",
          text: ""
        },
        {
          placeholder: "ID стоматолога",
          searchKey: "shopEmployeeId",
          text: ""
        },
        {
          placeholder: "Клиника",
          searchKey: "shopName",
          text: ""
        },
        {
          placeholder: "ID клиники",
          searchKey: "shopId",
          text: ""
        }
      ],

      complex: {
        selected: [],
        headers: [
          {
            text: "№",
            value: "index",
            sortable: false
          },
          {
            text: "Дата визита",
            value: "visitDate",
            sortable: false
          },
          {
            text: "Дата создания",
            value: "gpsTimestamp",
            sortable: false
          },
          {
            text: "Активен",
            value: "isActive",
            sortable: false
          },
          {
            text: "Имя ответственного",
            value: "fullName",
            sortable: false
          },
          {
            text: "ФИО стоматолога",
            value: "employeeName",
            sortable: false
          },
          {
            text: "ID стоматолога",
            value: "shopEmployeeId",
            sortable: false
          },
          {
            text: "Клиника",
            value: "shopName",
            sortable: false
          },
          {
            text: "ID клиники",
            value: "shopId",
            sortable: false
          },
          {
            text: "Тип",
            value: "visitTypeName",
            sortable: false
          },
          {
            text: "Визит в ТТ",
            value: "visitToShop",
            sortable: false
          },
          {
            text: "Действия",
            value: "",
            sortable: false
          }
        ],
        headersAnswer: [
          {
            text: "Вопрос",
            value: "questName",
            width: "350px"
          },
          {
            text: "Число",
            value: "",
            width: "50px"
          },
          {
            text: "Текст",
            value: ""
          },
          {
            text: "Действия",
            value: "",
            width: "100px"
          }
        ]
      },
      visitDateMenu: false
    };
  },
  watch: {
    /**
     * Проверяем на null в поиске, если был null то нужно обновить поиск (была отчистка поля)
     */
    detailedSearch: {
      handler: function () {
        let isNeedRefresh = false;
        this.detailedSearch.forEach(a => {
          if (a.text == null) {
            isNeedRefresh = true;
            a.text = "";
          }
        });
        if (isNeedRefresh) {
          console.log('NAU: isNeedRefresh', isNeedRefresh)
          this.refresh();
        }
      },
      deep: true
    }
  },

  computed: {
    /**
     * Данные по визитам
     * @returns {default.computed.visitData|(function())|Array|getters.visitData}
     */

    visitData() {
      return this.$store.getters["visit/visitData"];
    },

    /**
     * Кол-во записей по запросу
     */
    countVisits() {
      let count = 0;
      if (this.$store.getters["visit/visitCount"].length != 0) {
        count = this.$store.getters["visit/visitCount"][0].countVisits;
      }
      return count;
    },

    /**
     * Список стоматологов для select
     * @returns {*}
     */
    employeeList() {
      return this.$store.getters["employees/items"].map(item => {
        return {
          text: item.lastName + " " + item.firstName + " " + item.middleName,
          value: item.id
        };
      });
    },

    /**
     * Список клиник для select
     * @returns {*}
     */
    clinicList() {
      return this.$store.getters["clinics/items"].map(item => {
        return { text: (item.name || '') + ", " + (item.address || ''), value: item.id };
      });
    },
    /**
     * Список вопросов с анкетами и ответами
     */
    answerList() {
      return this.$store.getters["visit/answerData"];
    },
    /**
     * Список анкет. Фильтруем по признаку группа, типу сценария визита и наличию анкеты в визите
     */
    allPollList() {
      return this.$store.getters["pollTemplates/pollTemplatesData"]
        .filter(
          item => this.pollList.findIndex(poll => poll.pollId == item.Id) == -1
        )
        .map(item => {
          return { text: item.name, value: item.Id };
        });
    },
    /**
     * Список анкет в визите
     */
    pollList() {
      var pollArr = this.$store.getters["visit/answerData"].map(item => {
        return {
          pollId: item.pollId,
          pollName: item.pollName,
          docUid: item.docUid
        };
      });
      let tmpId = [];
      pollArr = pollArr.filter((rn, index) => {
        if (tmpId.indexOf(rn.pollId) == -1) {
          tmpId.push(rn.pollId);
          return rn.pollId;
        }
      });
      return pollArr;
    },

    /**
     * Список ответственных для select
     * @returns {*}
     */
    staffList() {
      return this.$store.getters["staff/staffData"].map(item => {
        return { text: item.pgName || '', value: item.id };
      });
    },
    /**
     * Список вопросов для select
     */
    pollQuestsData() {
      return this.$store.getters["pollQuests/pollQuestsData"].map(item => {
        return {
          text: item.name,
          value: item.Id,
          pollId: item.pollId,
          isRequired: item.isRequired
        };
      });
    },
    /**
     * Список вариантов ответов для подходящего вопроса
     */
    questValuesList() {
      return this.$store.getters["questionAnswers/items"]
        .filter(item => item.pollQuestsId === this.popupEditAnswer.data.questId)
        .map(item => {
          return { text: item.value, value: item.id };
        });
    }
  },

  mounted: function () {
    if (!this.$store.getters['staff/staffData'].length) {
      this.$store.dispatch('staff/getStaffData');
    }

    if (!this.$store.getters['clinics/items'].length) {
      this.$store.dispatch('clinics/loadItems');
    }

    if (!this.$store.getters['employees/items'].length) {
      this.$store.dispatch('employees/loadItems');
    }

    if (!this.$store.getters['pollQuests/pollQuestsData'].length) {
      this.$store.dispatch('pollQuests/getPollQuestsData');
    }

    if (!this.$store.getters['pollTemplates/pollTemplatesData'].length) {
      this.$store.dispatch('pollTemplates/getPollTemplatesData');
    }

    if (!this.$store.getters['log/logData'].length) {
      this.$store.dispatch('log/getLogData');
    }

    if (!this.$store.getters['questionAnswers/items'].length) {
      this.$store.dispatch('questionAnswers/loadItems');
    }

    if (!this.visitData.length) {
      this.refresh();
    }
  },

  methods: {
    /**
     * Нажатие в поле поиска на кнопку Enter
     */
    pressEnterSearch(e) {
      this.refresh();
    },
    /**
     * Нажатие на кнопку отчистки поля поиска
     */
    clearSearchField(e, b) {
      // не используем
    },
    /**
     * Обновление пагинации, отправка данных на сервер
     */
    updatePagination(pagination) {
      this.$store._actions["visit/getVisitData"][0](this.detailedSearch, {
        pagination: {
          start: pagination.page * pagination.rowsPerPage - 9,
          top: pagination.rowsPerPage
        }
      });
      this.$store._actions["visit/getVisitCountData"][0](this.detailedSearch);
      console.log("update:pagination", pagination);
    },
    /**
     * Обновление данных по визитам
     */
    refresh() {
      console.log('NAU: refresh -> refresh')
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 10;
      this.$store._actions["visit/getVisitData"][0](this.detailedSearch, {
        pagination: {
          start: this.pagination.page * this.pagination.rowsPerPage - 9,
          top: this.pagination.rowsPerPage
        }
      });
      this.$store._actions["visit/getVisitCountData"][0](this.detailedSearch);
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Фильтруем список стоматологов по клинике.
      this.employeeListVisit = [];
      this.$store.getters["employees/items"].forEach(employee => {
        if (employee.shopid === item.shopId) {
          this.employeeListVisit.push({
            text:
              (employee.lastName || '') +
              " " +
              (employee.firstName || '') +
              " " +
              (employee.middleName || ''),
            value: employee.id
          });
        }
      });
      this.changeEmployeeTrigger = true;
      this.popupEdit.isOpen = true;
      this.modalData = item;
      if (
        this.modalData.shopLatitude == 0 &&
        this.modalData.shopLongitude == 0
      ) {
        this.shopLocation = false;
      } else {
        this.shopLocation = true;
      }
      this.oldModalData = Object.assign({}, this.modalData);
      this.editIndex = this.visitData.indexOf(item);
    },
    /**
     * Отмена редактирования
     */
    editCancel() {
      Object.assign(this.visitData[this.editIndex], this.oldModalData);
      this.popupEdit.isOpen = false;
    },
    /**
     * Открытие модального окна с анкетами и вопросами , сохраняем старые данные  на случай отмены редактирования
     * @param item
     */
    answerOpen(item) {
      this.$store._actions["visit/getAnswerVisitData"]
      [0]({ data: item })
        .then(() => {
          this.popupAnswer.isOpen = true;
          this.popupAnswer.data = item;
        });
    },
    /**
     * Отмена просмотра вопросов с ответами
     */
    answerCancel() {
      this.popupAnswer.isOpen = false;
      this.popupAnswer.data = [];
    },
    /**
     * Удалить анкету
     */
    removePoll(item) {
      let removePoll = this.answerList.filter(
        answer => answer.pollId == item.pollId
      );
      this.removePollsUid.push(removePoll[0]["docUid"]);
      removePoll.forEach(element => {
        this.$store._actions["visit/removeAnswerData"][0]({ item: element });
      });
    },
    /**
     * добавление новых вопросов в анкету
     */
    newAnswerOpen(item) {
      this.filtredQuestData = this.pollQuestsData.filter(
        quest =>
          quest.pollId == item.pollId &&
          this.answerList.findIndex(answer => answer.questId == quest.value) ==
          -1
      );
      this.popupEditAnswer.data = {
        docUid: item.docUid,
        pollId: item.pollId,
        questId: null,
        pollName: item.pollName,
        questName: "",
        numberValue: null,
        textValue: "",
        isModifiedTV: false,
        photoUrl: ""
      };
      this.popupEditAnswer.isNew = true;
      this.popupEditAnswer.isQuestValues =
        this.$store.getters['questionAnswers/items'].filter(
          item => item.pollQuestsId === this.popupEditAnswer.data.questId
        ).length > 0;
      this.popupEditAnswer.isOpen = true;
    },
    /**
     * Открыть окно редактирования ответов
     */
    editAnswerOpen(item) {
      if (item.questId == 109 || item.questId == 145) {
        this.employeeListAnswer = [];
        this.$store.getters["employees/items"].forEach(employee => {
          if (employee.shopid === this.popupAnswer.data.shopId) {
            this.employeeListAnswer.push({
              text:
                (employee.lastName || '') +
                " " +
                (employee.firstName || '') +
                " " +
                (employee.middleName || ''),
              value: employee.id
            });
          }
        });
        this.isEmployeeQuest = true;
      } else {
        this.isEmployeeQuest = false;
      }

      this.filtredQuestData = this.pollQuestsData.filter(
        quest => quest.pollId == item.pollId
      );
      this.editAnswerIndex = this.answerList.indexOf(item);
      this.oldAnswerData = Object.assign({}, item);
      this.popupEditAnswer.isOpen = true;
      this.popupEditAnswer.data = item;
      this.popupEditAnswer.isQuestValues =
        this.$store.getters['questionAnswers/items'].filter(
          item => item.pollQuestsId === this.popupEditAnswer.data.questId
        ).length > 0;
    },
    /**
     * Закрыть окно редактирования ответа
     */
    editAnswerCancel() {
      if (!this.popupEditAnswer.isNew) {
        Object.assign(
          this.answerList[this.editAnswerIndex],
          this.oldAnswerData
        );
      } else {
      }
      this.popupEditAnswer.isNew = false;
      this.popupEditAnswer.isOpen = false;
    },
    /**
     * Сохранить изменения в выбранном вопросе
     */
    submitEditAnswer() {
      if (this.$refs.formQuest.validate()) {
        if (this.popupEditAnswer.isNew) {
          this.answerList.push(this.popupEditAnswer.data);
        }
        this.popupEditAnswer.isNew = false;
        this.popupEditAnswer.isOpen = false;
      }
    },
    /**
     * Удалить вопрос из анкеты
     */
    removeAnswer(item) {
      this.$store._actions["visit/removeAnswerData"][0]({ item: item });
    },
    /**
     * Сохранение изменения в ответах визита
     */
    submitAnswer() {
      let removePolls = {};
      let strPolls = "";
      this.$store._actions["visit/saveAnswerVisitData"]
      [0]({ data: this.answerList, visitUid: this.popupAnswer.data.visitUid })
        .then(() => {
          this.$store._actions["log/getLogData"][0]();
        });

      this.removePollsUid.forEach(element => {
        strPolls += element + "##";
      });

      removePolls.polls = strPolls;
      this.$store._actions["pollsRunProgram/removePollsData"][0]({
        item: removePolls
      });
      this.popupAnswer.isOpen = false;
      this.popupAnswer.data = [];
      this.removePollsUid = [];
    },
    /**
     * Изменение вопросв в модальном окне
     * @param event
     */
    changeQuests(event) {
      if (event !== null && typeof event === "object") {
        this.popupEditAnswer.data.questId = event.value;
        this.popupEditAnswer.data.questName = event.text;
      }
    },

    changeQuestValues(event) {
      if (event !== null && typeof event === "object") {
        this.popupEditAnswer.data.numberValue = event.value;
        this.popupEditAnswer.data.textValue = null;
      }
    },

    /**
     *
     */
    openAddTemplate() {
      this.popupAddTemplate.isOpen = true;
    },
    /**
     *
     */
    cancelAddTemplate() {
      this.popupAddTemplate.isOpen = false;
    },
    /**
     * Обработка события изменения анкеты
     * @param event
     */
    changeTemplate(event) {
      if (event !== null && typeof event === "object") {
        this.popupAddTemplate.newTemplateId = event.value;
        this.popupAddTemplate.newTemplateName = event.text;
      }
    },
    /**
     * Добавляем новую анкету и связанные вопросы
     */
    submitAddTemplate() {
      if (this.$refs.formTemplate.validate()) {
        let newDocUid = uuid.v1();
        this.filtredTemplateQuestData = this.pollQuestsData.filter(
          quest => this.popupAddTemplate.newTemplateId == quest.pollId
        );
        this.filtredTemplateQuestData.forEach(quest => {
          this.answerList.push({
            docUid: newDocUid,
            pollId: this.popupAddTemplate.newTemplateId,
            questId: quest.value,
            pollName: this.popupAddTemplate.newTemplateName,
            questName: quest.text,
            numberValue: null,
            textValue: "",
            isModifiedTV: false,
            photoUrl: ""
          });
        });
        this.popupAddTemplate.isOpen = false;
      }
    },
    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.oldModalData.visitToShop != this.modalData.visitToShop) {
        this.updateLocation = true;
      }

      this.$store._actions["visit/saveVisitData"]
      [0]({
        index: this.editIndex,
        data: this.modalData,
        updateLocation: this.updateLocation
      })
        .then(() => {
          this.popupEdit.isOpen = false;
          this.updateLocation = false;
          this.$store._actions["log/getLogData"][0]();
        });
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    deactivationConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    /**
     * Удаление элемента
     * @param item
     */
    actionDeactivation(item) {
      item.isActive = !item.isActive;
      this.$store._actions["visit/saveVisitData"][0]({
        data: item,
        updateLocation: this.updateLocation
      });
      //this.$store.commit('remove', {type: 'visitData', item: item});
      this.popupRemove.isOpen = false;
    },

    /**
     * Обработка события изменения ответственного
     * @param event
     */
    changeStaff(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.staffId = event.value;
        this.modalData.fullName = event.text;
        // меняем pgName, в зависимости от Staff
        const newStaff = this.$store.getters["staff/staffData"].filter(
          iStaff => iStaff.id === event.value
        );
        this.modalData.pgName = newStaff[0].pgName;
      }
    },

    /**
     * Обработка события изменения стоматолога
     * @param event
     */
    changeEmployee(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.shopEmployeeId = event.value;
        this.modalData.employeeName = event.text;
        this.changeEmployeeTrigger = true;
      }
    },

    /**
     * Обработка события изменения клиники
     * @param event
     */
    changeClinic(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.shopId = event.value;
        this.modalData.shopName = event.text;
      }
    },

    /**
     * Обработка события изменения даты
     * @param event
     */
    changeDate(event) {
      if (event !== null) {
        const date =
          event.getFullYear() +
          "-" +
          (event.getMonth() + 1 > 9
            ? event.getMonth() + 1
            : "0" + (event.getMonth() + 1)) +
          "-" +
          (event.getDate() > 9 ? event.getDate() : "0" + event.getDate()) +
          " " +
          (event.getHours() > 9 ? event.getHours() : "0" + event.getHours()) +
          ":" +
          (event.getMinutes() > 9
            ? event.getMinutes()
            : "0" + event.getMinutes()) +
          ":" +
          "00.000";
        this.modalData.visitDate = date;
      } else {
        this.modalData.visitDate = this.oldModalData.visitDate;
      }
    },

    /**
     * Очистка и закрытие детального фильтра
     */
    detailedSearchClear() {
      this.detailedSearch.forEach(s => (s.text = ""));
      this.refresh();
    },
    /**
     * Загрузка фотографий через компонент VueBase64FileUpload
     * @param dataUri  - Фото в Base64
     */
    onLoad(dataUri) {
      this.photoData = [];

      this.photoData.push({
        accountId: this.popupAnswer.data.accountId,
        dateVisit: this.popupAnswer.data.visitDate.slice(0, -7),
        base64Image: dataUri,
        docUid: this.popupEditAnswer.data.docUid,
        visitUid: this.popupAnswer.data.visitUid,
        fileName: uuid.v1(),
        partsRemaining: "0",
        partsTotal: "1",
        questId: this.popupEditAnswer.data.questId,
        shopName:
          this.popupAnswer.data.shopName +
          " " +
          this.popupAnswer.data.shopAddress +
          "",
        staffId: this.popupAnswer.data.staffId,
        staffName: this.popupAnswer.data.fullName
      });

      this.$store._actions["visit/uploadPhotoData"]
      [0]({ data: this.photoData })
        .then(item => {
          this.popupEditAnswer.data.textValue = item.data[0].fileName;
          this.photoData = [];
          this.popupEditAnswer.data.photoUrl =
            "https://services.adv-ant.ru" + item.data[0].fileName;
        });
    },

    onSizeExceeded(size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/ui/Visits.vue